import Vue from 'vue'

export var globalConf = new Vue({
    data: {
        //hostlink: 'https://vi.benchmarkpro.it/api/', //VI
        //hostlink: 'https://tv.benchmarkpro.it/api/', //TV
        //hostlink: 'https://bz.benchmarkpro.it/api/', //BZ
        hostlink: 'https://bo.benchmarkpro.it/api/', //BO
        //hostlink: 'http://localhost/api/',
        multilingua: false,
        lingue: {
            default: 'italiano',
            tipi: [
                {
                    text: 'Italiano',
                    value: 'italiano'
                }
            ]
        }
    }
})

//Imposta ricavi

//BO
/*
var ricavi = [[2500.00, 25000.00],
  [25000.00, 50000.00],
  [50000.00]]
*/

//BZ

export var ricavi = [[50000.00, 200000.00],
    [200000.00, 500000.00],
    [500000.00]]

// export var ricavi = ricavi

//Base dati utili a sidebarReports
export var sidebarReportsData = new Vue({
    data: {
        data: {
            aziende: [],
            office_code: {
                loaded: false,
                data: [
                    { id: 0, nome: 'Tutte le zone' }
                ]
            },
            year: {
                loaded: false,
                data: [
                    { value: null, text: 'Selezionare un anno' }
                ]
            },
            // trimestre: [
            //     { value: null, text: 'Selezionare un trimestre' },
            //     { value: 1, text: 'Primo trimestre' },
            //     { value: 2, text: 'Secondo trimestre' },
            //     { value: 3, text: 'Terzo trimestre' },
            //     { value: 4, text: 'Quarto trimestre' }
            // ],
            servizio: {
                loaded: false,
                data: [
                    { id: null, nome: 'Selezionare un servizio' }
                ]
            },
            tariffa: {
                loaded: false,
                data: [
                    { id: null, nome: 'Selezionare una tariffa' }
                ]
            },
            total: [
                { value: null, text: 'Selezionare un range di ricavi' },
                { value: 1, text: setRicavi(ricavi[0][0])+' - '+setRicavi(ricavi[0][1]) },
                { value: 2, text: setRicavi(ricavi[1][0])+' - '+setRicavi(ricavi[1][1]) },
                { value: 3, text: setRicavi(ricavi[2][0])+' in su' }
            ]
        }
    }
})

// Default filters sidebarReports
export var sidebarReportsValue = new Vue({
    data: {
        office_code: '',
        servizio: '',
        tariffa: '',
        total: null,
        year: null,
    }
    // data: {
    //     ricerca: '',
    //     zona: 0,
    //     anno1: null,
    //     anno2: null,
    //     trimestre1: null,
    //     trimestre2: null,
    //     categoria: null,
    //     sottocategoria: null,
    //     ricavi: null,
    //     criterio: false,
    //     azienda: {},
    //     info: []
    // }
})

function setRicavi(n){
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(n)
}